<template>
  <div>
    <div class="search-header">
      <div class="box-title">我的产品</div>
      <el-input v-model="dataForm.prodtName" style="width: 400px" placeholder="请输入">
        <el-button slot="append" icon="el-icon-search" type="primary" @click="getProductList">查询</el-button>
      </el-input>
    </div>
    <div class="filter-item">
      产品类型：<span
        v-for="item in prodtTypeList"
        :key="item.cd"
        class="item-type"
        :class="[dataForm.prodtType === item.cd ? 'active' : '']"
        @click="selectType(item)"
        >{{ item.nm }}</span
      >
    </div>
    <div class="filter-item">
      发布状态：<span
        v-for="item in statusList"
        :key="item.cd"
        class="item-type"
        :class="[dataForm.status === item.cd ? 'active' : '']"
        @click="selectType1(item)"
        >{{ item.nm }}</span
      >
    </div>
    <el-button type="primary" @click="gotoAddProduct">发布产品</el-button>
    <div class="flex-box">
      <div v-for="item in list" :key="item.id" class="ans-box">
        <div class="ans-box-item">
          <div>
            <div class="ans-box-title" :title="item.prodtName">{{ item.prodtName }}</div>
            <div class="ans-box-title-sub" :title="item.crtUserNm">{{ item.crtUserNm }}</div>
          </div>
          <div class="ans-box-tag" :class="'color' + item.status">{{ item.statusDsr }}</div>
        </div>
        <img class="product-img" :src="item.prodtPictureUrl" alt="" />
        <div class="ans-box-btns">
          <el-button type="text" @click="gotoDetail(item)">查看</el-button>
          <div v-if="showUp(item)" class="line" />
          <el-button v-if="showUp(item)" type="text" @click="handleUp(item)">上架</el-button>
          <div v-if="showDown(item)" class="line" />
          <el-button v-if="showDown(item)" type="text" @click="handleDown(item)">下架</el-button>
          <div v-if="showEdit(item)" class="line" />
          <el-button v-if="showEdit(item)" type="text" @click="handleEdit(item)">编辑</el-button>
          <div v-if="showDel(item)" class="line" />
          <el-button v-if="showDel(item)" type="text" @click="handleDel(item)">删除</el-button>
        </div>
      </div>
    </div>
    <div v-if="list.length === 0" class="no-msg">暂无数据</div>
    <el-pagination
      v-if="list.length"
      layout="prev, pager, next"
      :current-page="page.pageNo"
      :page-size="page.pageSize"
      :background="true"
      :total="total"
      @current-change="currentChangeHandle"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      total: 0,
      page: {
        pageNo: 1,
        pageSize: 10,
      },
      dataForm: {
        prodtType: '',
        status: '',
      },
      prodtTypeList: [],
      statusList: [],
      list: [],
    }
  },
  mounted() {
    this.getProductList()
    this.getEnum('ZzmhProductEn$ProdtType', 'prodtTypeList')
    this.getEnum('ZzmhProductEn$Status', 'statusList')
  },
  methods: {
    showDel(item) {
      return item.status === 2 || item.status === 4 || item.status === 3
    },
    showDown(item) {
      return item.status === 1
    },
    showUp(item) {
      return item.status === 2
    },
    showEdit(item) {
      return true
    },
    getEnum(code, key) {
      this.$http({ method: 'get', url: `/general/enum/list?cls=${code}` }).then((res) => {
        this[key] = [{ nm: '全部', cd: '' }, ...res.data.list]
      })
    },
    gotoAddProduct() {
      this.$router.push({
        path: '/user/product/add',
      })
    },
    handleEdit(item) {
      this.$router.push({
        path: `/user/product/add?id=${item.id}`,
      })
    },
    gotoDetail(item) {
      this.$router.push({
        path: `/user/product/detail?id=${item.id}`,
      })
    },
    handleUp(item) {
      this.$confirm('确定上架此产品?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http({ method: 'get', url: '/zzmh/in/product/up?id=' + item.id }).then((res) => {
          this.$message({
            type: 'success',
            message: '操作成功!',
          })
          this.getProductList()
        })
      })
    },
    handleDown(item) {
      this.$confirm('确定下架此产品?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http({ method: 'get', url: '/zzmh/in/product/down?id=' + item.id }).then((res) => {
          this.$message({
            type: 'success',
            message: '操作成功!',
          })
          this.getProductList()
        })
      })
    },
    handleDel(item) {
      this.$confirm('确定删除此产品?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$http({ method: 'get', url: '/zzmh/in/product/del?id=' + item.id }).then((res) => {
            this.$message({
              type: 'success',
              message: '操作成功!',
            })
            this.getProductList()
          })
        })
        .catch(() => {})
    },
    handleSizeChange(val) {
      this.page.pageNo = 1
      this.page.pageSize = val
      this.getProductList()
    },
    currentChangeHandle(val) {
      this.page.pageNo = val
      this.getProductList()
    },
    selectType(item) {
      this.dataForm.prodtType = item.cd
      this.getProductList()
    },
    selectType1(item) {
      this.dataForm.status = item.cd
      this.getProductList()
    },
    getProductList() {
      let query = this.$query.new()
      this.$query.toF(query, this.dataForm)
      this.$query.toP(query, this.page.pageNo, this.page.pageSize)
      let params = {}
      this.$http({ method: 'get', url: '/zzmh/in/product/selfPage?query=' + encodeURIComponent(this.$query.toJsonStr(query)), params }).then((res) => {
        console.log(res)
        this.list = res.data.list.map((el) => {
          return {
            ...el,
            prodtPictureUrl: (el.prodtPictureUrl || '').split(',')[0],
          }
        })
        this.total = res.page.total
      })
    },
  },
}
</script>

<style lang="less" scoped>
@media screen {
  .no-msg {
    margin: 50px 0;
    text-align: center;
  }
  .search-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    .box-title {
      font-family: PingFangSC-Semibold;
      font-size: 18px;
      color: #333333;
      letter-spacing: 0;
      font-weight: 600;
    }
  }
  .filter-item {
    font-size: 16px;
    padding-bottom: 20px;
    line-height: 24px;
  }
  .flex-box {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
  }
  .ans-box {
    background: #ffffff;
    box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.02);
    border-radius: 10px;
    padding: 12px 12px 0 12px;
    border: 1px solid #eee;
    width: 270px;
    margin-left: 10px;
    margin-bottom: 12px;
    .product-img {
      width: 100%;
      height: 120px;
      object-fit: cover;
    }
    .ans-box-btns {
      display: flex;
      font-size: 16px;
      justify-content: center;
      align-items: center;
      /deep/.el-button {
        width: 50px;
      }
      .line {
        width: 2px;
        height: 15px;
        background: #e6e6e6;
        display: inline-block;
        margin: 0 12px;
      }
    }
    .ans-box-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      .ans-box-title {
        width: 210px;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #333333;
        font-weight: 500;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .ans-box-title-sub {
        width: 210px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #666666;
        letter-spacing: 0;
        font-weight: 400;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      .ans-box-tag {
        background: #f6ffed;
        border: 1px solid rgba(217, 247, 190, 1);
        border-radius: 4px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #52c41a;
        line-height: 22px;
        font-weight: 400;
        padding: 2px 4px;
        // 已上架
        &.color1 {
          border-color: rgba(217, 247, 190, 1);
          background: #f6ffed;
          color: #52c41a;
        }
        // 已下架
        &.color2 {
          border-color: #eee;
          background: #e7e7e7;
          color: rgba(0, 0, 0, 0.25);
        }
        // 待审核
        &.color3 {
          border-color: rgba(255, 241, 184, 1);
          background: #fffbe6;
          color: #faad14;
        }
        // 未通过
        &.color4 {
          border-color: rgba(255, 204, 199, 1);
          background: #fff1f0;
          color: #ff4d4f;
        }
      }
    }
  }
  .item-type {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #666666;
    letter-spacing: 0;
    text-align: center;
    font-weight: 400;
    margin-right: 10px;
    cursor: pointer;
    &.active {
      color: #1b5bfa;
      font-family: PingFangSC-Semibold;
    }
  }
  @media (min-width: 769px) {
  }

  @media (max-width: 768px) {
  }
}
</style>
